import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './event-type-selector-category.css'

const EventTypeSelectorCategory = ({ categories, value, onChange }) => (
  <div>
    <select styleName="select" value={value || ''} onChange={onChange}>
      <option key="" value="">Choose a category ...</option>
      {categories.map(category => <option key={category.key} value={category.key}>{category.name}</option>)}
    </select>
  </div>
)

EventTypeSelectorCategory.propTypes = {
  categories: PropTypes.array,
  onChange: PropTypes.func,
  value: PropTypes.string,
}

export default CSSModules(EventTypeSelectorCategory, styles)



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/field/event-type-selector/event-type-selector-category/event-type-selector-category.js
 **/